import Service from "../../../Services/index";

const ProductType = {
    namespaced: true,
    state: {
        data: []
    },
    mutations: {
        GET_PRODUCT_TYPE: (state, res) => {
            state.data = res;
        }
    },
    actions: {
        get({ commit }) {
            return Service.productType.getProductType().then(response => {
                commit("GET_PRODUCT_TYPE", response);
            });
        }
    }
};

export default ProductType;
